// ImportTriggerButton — brief 84 band B, candidate B44 (the cross-view pair).
// The Import button the two views' time-entry toolbars rendered
// byte-identically (modulo one trailing comma). The candidate's OTHER seven
// blocks are its siblings — the App pair at padding "3px 9px" (a value hunk,
// B48's class) and the Export twins (13 hunks: icon, label, handler) — all
// declared survivors, reported, not absorbed.
import { Upload } from "lucide-react";
import { FS } from "../lib/tokens";

export function ImportTriggerButton({ teFileRef, t }: any) {
  return (
                        <button
                          className="btn btn-ghost"
                          style={{ padding: "2px 7px", fontSize: FS.s10 }}
                          onClick={() => teFileRef.current?.click()}
                        >
                          <Upload
                            size={10}
                            style={{ marginRight: 3, verticalAlign: "middle" }}
                          />
                          {t("common.import", { fallback: "Import" })}
                        </button>
  );
}
